import Vue from 'vue';
export default new Vue({
  name: 'bus',
  data: {
    showIndex: 0
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/bus.js